const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/inbox/priority/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { priorityInboxSearchSchema } from "@circle-react/pages/UnifiedInbox/PriorityInbox/priorityInboxSearchParamsSchema";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/settings/inbox/priority")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: priorityInboxSearchSchema
});